import { BaseResourceStore } from "_common/resources/BaseResourceStore";
import { action, observable } from "mobx";
import { LoadingStateMdl } from "_common/loaders/_models/LoadingStateMdl";
import { fetchUtils } from "_common/_utils/fetchUtils";
import { TLeadMdl } from "leads/_models/LeadMdl";
import i18next from "i18next";

class LeadsStore extends BaseResourceStore<TLeadMdl> {
    @observable lead: TLeadMdl | undefined = undefined;
    @observable leadState = new LoadingStateMdl<TLeadMdl>();

    constructor() {
        super("developerNotifications");
        this.onInit();
    }

    @action fetchLeadById(leadId: string) {
        if (!this.leadState.isLoading) {
            this.leadState.startLoading();
            this.lead = undefined;
            const promise = fetchUtils.get<TLeadMdl>(`${this.apiPath}/leads/${leadId}?lang=${i18next.language}`);
            promise.then(
                ({ data }) => {
                    this.leadState.setSuccess(data);
                    this.lead = data;
                },
                (error) => {
                    this.leadState.setError(error);
                },
            );
        }
    }
}

export const leadsStore = new LeadsStore();
